import React, { ChangeEventHandler } from 'react';
import { SelectProps } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SwitchComponent from './Switch.component';
import SelectComponent from '@ui/components/Select/Select.component';
import InputComponent from '@ui/components/Input/Input.component';
import useDictionary from '@ui/hooks/useDictionary';
import { emptyFn } from '@core/interfaces/emptyFn';
import { lang } from '@lang/interfaces/lang';

interface IProps {
    lang: lang;
    gnssPowersave: boolean;
    gnssMinSearchTime: number;
    gnssMinSearchTimeError: boolean;
    gnssMaxSearchTime: number;
    gnssMaxSearchTimeError: boolean;
    gnssRectificationTime: number;
    onGnssPowersaveChange: emptyFn;
    onGnssMinSearchTimeChange: ChangeEventHandler<HTMLInputElement>;
    onGnssMaxSearchTimeChange: ChangeEventHandler<HTMLInputElement>;
    onGnssRectificationTimeChange: SelectProps['onChange'];
    onInputClick: emptyFn;
}

const Component: React.FC<IProps> = ({
    lang,
    gnssPowersave,
    gnssMinSearchTime,
    gnssMinSearchTimeError,
    gnssMaxSearchTime,
    gnssMaxSearchTimeError,
    gnssRectificationTime,
    onGnssPowersaveChange,
    onGnssMinSearchTimeChange,
    onGnssMaxSearchTimeChange,
    onGnssRectificationTimeChange,
    onInputClick,
}: IProps) => {
    const getWord = useDictionary();
    const timeOptions = [0, 1, 3, 5, 10, 20, 30, 45];

    return (
        <FormControl className="device-settings__form" component="form">
            <SwitchComponent
                alarmState={gnssPowersave}
                name={'gnssPowersave'}
                tooltip={getWord('gnssPowersaveTooltip')}
                onAlarmStateChange={onGnssPowersaveChange}
            />
            <InputComponent
                label="gnssMinSearchTime"
                name="gnssMinSearchTime"
                type="number"
                helperText="gnssMinSearchTimeHelper"
                description="gnssMinSearchTimeTooltip"
                errorMessage="gnssMinSearchTimeError"
                lang={lang}
                value={gnssMinSearchTime}
                numberProps={{
                    min: 60,
                    max: 180,
                    step: 10,
                }}
                disabled={!gnssPowersave}
                error={gnssMinSearchTimeError}
                onChange={onGnssMinSearchTimeChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="gnssMaxSearchTime"
                name="gnssMaxSearchTime"
                type="number"
                helperText="gnssMaxSearchTimeHelper"
                description="gnssMaxSearchTimeTooltip"
                errorMessage="gnssMaxSearchTimeError"
                lang={lang}
                value={gnssMaxSearchTime}
                numberProps={{
                    min: 5,
                    max: 15,
                }}
                error={gnssMaxSearchTimeError}
                onChange={onGnssMaxSearchTimeChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <SelectComponent
                label="gnssRectificationTime"
                name="gnssRectificationTime"
                description="gnssRectificationTimeTooltip"
                helperText="gnssRectificationTimeHelper"
                lang={lang}
                value={gnssRectificationTime}
                values={timeOptions}
                onChange={onGnssRectificationTimeChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
        </FormControl>
    );
};

const AdvancedGnssSettingsComponent = React.memo(Component);

export default AdvancedGnssSettingsComponent;
